import { makeElementAnchor, getTargetElement } from "views/components/visualizations/OnClickPopover/anchors";
import dropdownPopover from "views/components/visualizations/OnClickPopover/dropdownPopover";
import HeatmapOnClickPopover from "views/components/visualizations/OnClickPopover/HeatmapOnClickPopover";
const buildAnchor = (e, gd) => makeElementAnchor(e, gd, getTargetElement);
const heatmapOnClickPopover = {
  buildAnchor,
  renderPopover: dropdownPopover(HeatmapOnClickPopover)
};
export default heatmapOnClickPopover;
